<script lang="ts">
  import { onMount } from 'svelte';
  import IntersectionObserver from './IntersectionObserver.svelte';
  import Content from './Content.svelte';

  export let src: string | File = '....jpeg'; // must be set
  export let lowResSrc: any = null;
  export let controls: boolean = false;
  export let autoplay: boolean = true;
  export let mute: boolean = true;

  export let element: HTMLImageElement | HTMLVideoElement = null;
  export let rounded: boolean = false;

  let nativeLoading = false;

  // Determine whether to bypass our intersecting check
  onMount(() => {
    if ('loading' in HTMLImageElement.prototype || 'loading' in HTMLVideoElement.prototype) {
      nativeLoading = true;
    }
  });
</script>

<IntersectionObserver bind:rounded on:click once={true} let:intersecting>
  {#if typeof src === 'string'}
    {#if intersecting || nativeLoading}
      <Content
        bind:element
        on:click
        class={$$props.class}
        {controls}
        {mute}
        {autoplay}
        {lowResSrc}
        {src}
      />
    {/if}
  {/if}
</IntersectionObserver>
